import { CountryCode } from 'libphonenumber-js';

const entityPrefix = mapHostnameToEntityPrefix(window.location.hostname);

const SUNDAY_GATEWAY_URL = getEnvVar('SUNDAY_GATEWAY_URL', '');

export const config = {
  ASSET_PREFIX: getEnvVar('ASSET_PREFIX', ''),
  SERVICE_AREA: getEnvVar('SERVICE_AREA', 'TH') as CountryCode,
  AVAILABLE_LOCALES: getEnvVar('AVAILABLE_LOCALES', 'en,id').split(','),
  DEFAULT_LOCALE: getEnvVar('DEFAULT_LOCALE', 'id'),
  CUSTOMER_SERVICE_PHONENUMBER: getEnvVar('CUSTOMER_SERVICE_PHONENUMBER', '0 2026 3355'),
  ICECREAM_URL: 'https://icecream.co.id',
  GOOGLE_MAP_KEY: getEnvVar('GOOGLE_MAP_KEY', ''),

  SUNDAY_GATEWAY_URL,
  MEDIA_URL: `${SUNDAY_GATEWAY_URL}/api/media/v1.0`,
  GTM_ID: getEnvVar('GTM_ID'),
  GTM_AUTH: getEnvVar('GTM_AUTH'),
  GTM_PREVIEW: getEnvVar('GTM_PREVIEW'),

  SENTRY_DSN: getEnvVar('SENTRY_DSN'),
  SENTRY_ENVIRONMENT: getEnvVar('SENTRY_ENVIRONMENT', 'staging'),
  SENTRY_SAMPLERATE: parseInt(getEnvVar('SENTRY_SAMPLERATE', '1.0')),
  SENTRY_TRACESSAMPLERATE: parseInt(getEnvVar('SENTRY_TRACESSAMPLERATE', '0.3')),
};

function mapHostnameToEntityPrefix(hostname: string): string {
  switch (true) {
    case hostname.endsWith('.easysunday.tech'):
      return 'SDT_';
    case hostname.endsWith('.easysunday.com') || hostname.endsWith('.easysunday.co.id'):
      return 'SDB_';
    case hostname.endsWith('.easysunday.care'):
      return 'SDC_';
    case hostname.endsWith('.sundayinsurance.co.th') || hostname.endsWith('.sundayinsurance.co.id'):
      return 'SDI_';
    case hostname.endsWith('.jollyinsure.com'):
      return 'JOL_';
    default:
      return '';
  }
}

function getEnvVar(envName: string, defaultValue?: string): string | undefined {
  return process.env[`${entityPrefix}${envName}`] || process.env[envName] || defaultValue;
}
